var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass:
        "--bgSolid --withBorder d-flex justify-content-between align-items-center"
    },
    [
      _c("img", {
        staticClass: "img-fluid header__logo",
        attrs: {
          src: "assets/img/adoptuj-kravicku-logo.svg",
          alt: "adoptuj-kravicku-logo"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header__right d-flex" },
        [
          _vm.$route.name == "login"
            ? _c(
                "div",
                {
                  staticClass:
                    "o-registerInfo d-md-flex align-items-center d-none"
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "m-registerInfo__btn ml-3" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn --primary",
                          attrs: { to: { name: "register" } }
                        },
                        [
                          _vm._v(
                            "\n                    Registrovať sa\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.name == "register"
            ? _c(
                "div",
                {
                  staticClass:
                    "o-registerInfo d-md-flex align-items-center d-none"
                },
                [_vm._m(1)]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              class: "hamburger hamburger--elastic" + _vm.isActive,
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.sidemenu()
                }
              }
            },
            [_vm._m(2)]
          ),
          _vm._v(" "),
          _c("menu-side", { attrs: { isActive: _vm.isActive } })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "m-registerInfo__description d-none d-lg-block" },
      [
        _c("p", { staticClass: "mb-0" }, [
          _vm._v("Ešte nemáte vytvorené konto?")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-registerInfo__btn ml-3" }, [
      _c(
        "a",
        {
          staticClass: "btn --primary",
          attrs: {
            href: "https://adoptujkravicku.sk/pravidla-pouzivania/",
            target: "_blank"
          }
        },
        [_vm._v("Pravidlá hry")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "hamburger-box" }, [
      _c("span", { staticClass: "hamburger-inner" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }